import { FC } from 'react';

const ErrorIcon: FC = () => {
    return (
        <svg
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M24.0008 24V14.4M24.0008 31.1157V31.2M43.2008 24C43.2008 34.6039 34.6046 43.2 24.0008 43.2C13.3969 43.2 4.80078 34.6039 4.80078 24C4.80078 13.3962 13.3969 4.80005 24.0008 4.80005C34.6046 4.80005 43.2008 13.3962 43.2008 24Z"
                stroke="#F0626B"
                strokeWidth="4"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export { ErrorIcon };
